import React from 'react';
import Type from 'prop-types';
import { FileCopy as FileCopyIcon } from "@mui/icons-material";
import { useCopyToClipboard } from 'hooks';

export const CopyToClipboardIconButton = (props) => {
  const { data, successCopyMessage, buttonStyle } = props;
  const copyToClipboard = useCopyToClipboard(data, successCopyMessage);

  return <FileCopyIcon onClick={copyToClipboard} className={buttonStyle} />;
};

CopyToClipboardIconButton.propTypes = {
  data: Type.string.isRequired,
  successCopyMessage: Type.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  buttonStyle: Type.any.isRequired,
};
